/**
 * Sanitizes form data by removing empty values and 'all' values
 * @param data Form data to sanitize
 * @returns Sanitized data object
 */
export const sanitizeFormData = <T extends Record<string, any>>(data: T): Record<string, string> => {
  const sanitizedData: Record<string, string> = {};
  for (const [key, value] of Object.entries(data)) {
    if (value && value !== 'all') {
      sanitizedData[key] = value;
    }
  }
  return sanitizedData;
};

/**
 * Compares two objects to detect if there are any changes
 * @param newData New data to compare
 * @param currentData Current data to compare against
 * @returns Boolean indicating if the data has changed
 */
export const hasFormDataChanged = (
  newData: Record<string, any>,
  currentData: Record<string, any>
): boolean => {
  const currentKeys = Object.keys(currentData);
  const newKeys = Object.keys(newData);
  
  // Quick length check first
  if (currentKeys.length !== newKeys.length) {
    return true;
  }
  
  // Check individual values
  return newKeys.some(key => newData[key] !== currentData[key]);
};